module.exports = __webpack_public_path__ + "static/media/picture-(276).358c3ac7.JPG";